document.addEventListener('DOMContentLoaded', () => {
  const productBlock = document.querySelector('.variant-picker__option:last-of-type > .variant-picker__option-info');
  //add console logging here to log productBlock for debugging if necessary
  let isInjected = false;  

  if (productBlock) {
    
    const pbObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {

        const kiwi = document.querySelector('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
        //add console logging here to log Kiwi's container for debugging if necessary
        if (!kiwi && !isInjected) {
          loadKiwiSizingChart();
          isInjected = true;  
        }
      });
    });

    pbObserver.observe(productBlock, 
      { attributes: false, 
        childList: true, 
        subtree: true 
      });

    setInterval(() => {
      const allCharts = document.querySelectorAll('div.ks-chart-container.sizing-chart-container.ks-container-with-modal');
      if (allCharts.length === 0) {
        loadKiwiSizingChart();
        isInjected = true;
      } else if (allCharts.length > 1) {
        allCharts.forEach((chart, index) => {
          if (index > 0) chart.remove();
        });
      } else {
        isInjected = false;  
      }
    }, 500); 
  } else {

    }
});
